export const AWS_CREDENTIALS = {
  AWS_ALBUM_BUCKET_NAME: "lung.audio",
  AWS_BUCKET_REGION: "us-east-2",
  AWS_IDENTITY_POOL_ID: "us-east-2:ec444e27-ba6c-4aca-9e46-92e779267776",
  AWS_ACL: "bucket-owner-full-control",
};
